import { Button } from "../components/Button";
import { Questions } from "../components/Questions";
import { useContext, useState } from "react";
import { useRoom } from "../hooks/useRoom";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../App";
import logoImg from "../assets/images/logo.svg"
import copySimbol from "../assets/images/copy.svg"
import { push, ref, remove, set, update } from "firebase/database";
import { database } from "../services/Firebase";

type typeParams = {
    id: string;
}

export function AdmRoom() {
    const params = useParams<typeParams>();
    const roomId = params.id!;
    const { questions, title, numberOfQuestions } = useRoom(roomId);
    const navigation = useNavigate();

    function copyRoomCodeToClipboard() {
        navigator.clipboard.writeText(params.id!);
        alert("copied");
    }

    async function removeRoom() {
        await update(ref(database, `rooms/${roomId}`), {endedAt: new Date()});

        navigation("/");
    }

    return (
        <div id="page-room">
            <header>
                <img src={logoImg} alt="Logo letmeask"/>
                <div>
                    <button onClick={copyRoomCodeToClipboard}>
                        <img src={copySimbol} alt="Símbolo de cópia"/>
                        <div>{params.id}</div>
                    </button>
                    <Button onClick={removeRoom} id="remover-sala">Encerrar sala</Button>
                </div>
            </header>
            <body>
                <div>
                    <h1>Sala {title}</h1>
                    <div id="titulo">{numberOfQuestions} pergunta(s)</div>
                </div>
                {
                    questions.map(Question => {
                        return (
                            <Questions
                                key={Question.id}
                                content={Question.content}
                                author={Question.author}
                                roomId = {roomId}
                                chave={Question.id}
                                likeCount={Question.likeCount}
                                hasLiked={Question.hasLiked}
                                admin
                            ></Questions>
                        )
                    })
                }
            </body>
        </div>
    );
}